import { MapPin, Phone, Mail } from 'lucide-react';
import { useSiteData } from '../context/SiteContext';

export const Footer = () => {
  const { data } = useSiteData();
  const currentYear = new Date().getFullYear();

  const settings = data?.settings || {
    address: 'г. Красноярск',
    phone: '+7 (391) 272-24-12',
    email: 'info@fipi.pro',
    working_hours: 'Пн-Вс: 24/7'
  };

  return (
    <footer className="bg-[#020617] pt-16 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-accent to-blue-700 flex items-center justify-center text-white font-bold text-xl shadow-lg glow-effect">
                F
              </div>
              <span className="text-2xl font-black tracking-tight text-white">FIPI<span className="text-accent">.PRO</span></span>
            </div>
            <p className="text-slate-400 mb-6 max-w-sm">
              Профессиональный хостинг и аренда виртуальных серверов (VPS/VDS). Высокая производительность, надежность и безопасность для вашего бизнеса.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-bold mb-6">Навигация</h4>
            <ul className="space-y-4">
              <li><a href="#hero" className="text-slate-400 hover:text-accent transition-colors">Главная</a></li>
              <li><a href="#features" className="text-slate-400 hover:text-accent transition-colors">Преимущества</a></li>
              <li><a href="#pricing" className="text-slate-400 hover:text-accent transition-colors">Тарифы</a></li>
            </ul>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="text-white font-bold mb-6">Контакты</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <span className="text-slate-400">{settings.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-accent shrink-0" />
                <a href={`tel:${settings.phone.replace(/[^0-9+]/g, '')}`} className="text-slate-400 hover:text-accent transition-colors">
                  {settings.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-accent shrink-0" />
                <a href={`mailto:${settings.email}`} className="text-slate-400 hover:text-accent transition-colors">
                  {settings.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            © {currentYear} FIPI.PRO. Все права защищены.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-slate-500 hover:text-slate-300 transition-colors">Политика конфиденциальности</a>
            <a href="#" className="text-slate-500 hover:text-slate-300 transition-colors">Договор оферты</a>
          </div>
        </div>
      </div>
    </footer>
  );
};